module.exports = __webpack_public_path__ + "static/media/LA-NET.91cc1002.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/LA-NET.png
// module id = 259
// module chunks = 0